module.exports = __webpack_public_path__ + "static/wfp-still-518639bb75c9bde999e702ed5465e3a6.jpg";